// BranchesDashboard/index.js
import React from 'react';

import BranchRecordsItemsList from '../../containers/BranchRecordsItemsList';
import BranchesViewPanel from '../../containers/BranchesViewPanel';

function BranchesDashboard(props) {
  return (
    <React.Fragment>
      <BranchRecordsItemsList />
      <BranchesViewPanel />
    </React.Fragment>
  );
}

BranchesDashboard.propTypes = {
  // describe the component's prop types here
};

BranchesDashboard.defaultProps = {
  // assign default props to the component here
};

export default BranchesDashboard;
